import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useRef } from 'react';

interface OTPProps {
  onSubmit: (otp: string) => void;
  color: string;
  textColor: string;
  title?: string;
  btnText?: string;
}

const OtpInput: React.FC<OTPProps> = ({
  onSubmit,
  color,
  textColor,
  title,
  btnText,
}) => {
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    setFieldValue: (field: string, value: string[]) => void,
    values: string[]
  ) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      const newOtp = [...values];
      newOtp[index] = val;
      setFieldValue('otp', newOtp);
      if (val && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  return (
    <Formik
      initialValues={{ otp: ['', '', '', '', '', ''] }}
      validationSchema={Yup.object({
        otp: Yup.array()
          .of(Yup.string().matches(/^\d$/, 'Only digits allowed'))
          .test('is-complete', 'OTP must be 6 digits', (value) =>
            value?.every((v) => v?.length === 1)
          ),
      })}
      onSubmit={(values) => {
        const otpString = values.otp.join('');
        onSubmit(otpString);
      }}
    >
      {({ errors, touched, values, setFieldValue }) => (
        <>
          <div className="mb-1 text-center text-sm text-gray-600">{title}</div>
          <Form className="grid grid-cols-12 gap-x-2 gap-y-4">
            <div className="col-span-full mt-3 flex justify-center gap-2">
              {values.otp.map((val, index) => (
                <input
                  key={index}
                  ref={(el) => (inputsRef.current[index] = el)}
                  type="text"
                  maxLength={1}
                  value={val}
                  onChange={(e) =>
                    handleInputChange(e, index, setFieldValue, values.otp)
                  }
                  className={`input-costume h-12 w-11 rounded border text-center text-xl ${
                    errors.otp && touched.otp
                      ? 'border-red-500'
                      : 'border-gray-300'
                  } focus:outline-none`}
                  style={
                    {
                      '--button-color': color,
                    } as React.CSSProperties
                  }
                />
              ))}
            </div>
            {errors.otp && touched.otp && (
              <div className="col-span-full mt-1 text-center text-sm text-red-500">
                {(errors.otp as string) || ''}
              </div>
            )}
            <div className="col-span-full">
              <button
                type="submit"
                style={{
                  backgroundColor: color || '#5D87FF',
                  color: textColor,
                }}
                className="w-full rounded-md px-4 py-2.5 font-medium text-white shadow-sm"
              >
                {btnText}
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default OtpInput;
